import { render } from "./laborOfflinePage.vue?vue&type=template&id=d1261e6a&scoped=true"
import script from "./laborOfflinePage.vue?vue&type=script&lang=js"
export * from "./laborOfflinePage.vue?vue&type=script&lang=js"

import "./laborOfflinePage.vue?vue&type=style&index=0&id=d1261e6a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1261e6a"]])

export default __exports__